const LotesProdutoConsultaController = ControllerBase.extend({
    name: "LotesProdutoConsultaController",
    framework: "knockout",

    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.produto.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function() {

        this.filtros = {
            CodigoProduto: this.produto.get("IdentificadorOrcamento") ? this.produto.get("CodigoProduto") : this.produto.get("Codigo"), // FNX-998, FNX-999, FNX-1001
            Filial: null,
            NumeroPagina: 1,
            TamanhoPagina: 10
        };

        return {
            url: "/Produto/_LotesProdutoConsulta",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: this.filtros
            })
        };
    },
    antesBinding: function() {

        var referenciaProduto = this.produto.get("ReferenciaProduto")
            ? this.produto.get("ReferenciaProduto")
            : this.produto.get("Referencia")
            ? this.produto.get("Referencia")
            : this.produto.get("Codigo");

        this.appendToModel({ name: "Filial", value: null });
        this.appendToModel({ name: "DescricaoProduto", value: this.produto.get("DescricaoProduto") });
        this.appendToModel({ name: "referenciaProduto", value: referenciaProduto });
    },

    aposBinding: function() {
        if (this.data) {
            this.atualizarPaginador(this.data.Lotes);
        }

        this.model.Filial.subscribe($.proxy(this.filialAlterada, this));
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    filialAlterada: function() {
        this.filtros.Filial = this.model.Filial();
        this.pesquisar();
    },
    pesquisar: function(pagina) {
        var self = this;
        this.filtros.NumeroPagina = pagina || 1;
        global.ajax({
            url: "/Produto/ListarLotesProduto",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString({
                filtros: this.filtros
            }),
            success: function(data) {
                if (!data || data.HasErrors) {
                    self.model.Lotes().Entities.removeAll();
                    self.model.Totais().QuantidadeSaidaLote(undefined);
                    self.model.Totais().QuantidadeReservaLote(undefined);
                    self.model.Totais().QuantidadeDisponivelVenda(undefined);
                    self.model.Totais().QuantidadeBloqueadoVenda(undefined);
                    return;
                }
                var m = ko.mapping.fromJS(data.Lotes.Entities);
                self.model.Lotes().Entities(m());
                self.atualizarPaginador(data.Lotes);

                var t = ko.mapping.fromJS(data.Totais);
                self.model.Totais(t);

                self.model.QuantidadeSaidaLotePagina(data.QuantidadeSaidaLotePagina);
                self.model.QuantidadeReservaLotePagina(data.QuantidadeReservaLotePagina);
                self.model.QuantidadeDisponivelVendaPagina(data.QuantidadeDisponivelVendaPagina);
                self.model.QuantidadeBloqueadoVendaPagina(data.QuantidadeBloqueadoVendaPagina);

            }
        });
    },

    atualizarPaginador: function(data) {

        this.paginador = new Paginator({
            container: "#page-consulta-lotes",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

    },

    paginar: function(e) {
        this.pesquisar(e.page);
    },
})

window.LotesProdutoConsultaController = LotesProdutoConsultaController

export {
    LotesProdutoConsultaController
}